import {
  PropertyPortal,
  PropertyPortalPublicationDisplayStatusFilter,
} from 'src/api/generated';
import { z } from 'zod';
import {
  propertiesSearchSchema,
  type PropertiesSearch,
} from './properties-search.schema';
import { PROPERTY_PUBLICATION_STATUS_FILTER_OPTIONS } from '../utils/property-publications-filters.util';

export const propertyPublicationPortalFilterValues = [
  'ALL',
  PropertyPortal.MELI,
] as const;

const propertyPublicationDisplayStatusFilterValues =
  PROPERTY_PUBLICATION_STATUS_FILTER_OPTIONS as [
    PropertyPortalPublicationDisplayStatusFilter,
    ...PropertyPortalPublicationDisplayStatusFilter[],
  ];

export const propertyPublicationsSearchSchema = propertiesSearchSchema.extend({
  publicationStatus: z
    .enum(propertyPublicationDisplayStatusFilterValues)
    .catch(PropertyPortalPublicationDisplayStatusFilter.ALL)
    .default(PropertyPortalPublicationDisplayStatusFilter.ALL),
  publicationPortal: z
    .enum(propertyPublicationPortalFilterValues)
    .catch('ALL')
    .default('ALL'),
});

export type PropertyPublicationPortalFilter =
  (typeof propertyPublicationPortalFilterValues)[number];

export type PropertyPublicationsSearch = z.infer<
  typeof propertyPublicationsSearchSchema
>;

export const toPropertyPublicationsSearch = (
  search: PropertiesSearch
): PropertyPublicationsSearch =>
  propertyPublicationsSearchSchema.parse({
    ...search,
    publicationStatus:
      search.publicationStatus ??
      PropertyPortalPublicationDisplayStatusFilter.ALL,
    publicationPortal: 'ALL',
  });

export const toPropertiesBackSearch = (
  search: PropertyPublicationsSearch
): PropertiesSearch =>
  propertiesSearchSchema.parse({
    phoneVersion: search.phoneVersion,
    search: search.search,
    operation: search.operation,
    activeStatus: search.activeStatus,
    sortBy: search.sortBy,
    viewMode: search.viewMode,
    pageSize: search.pageSize,
    userId: search.userId,
    salePriceMin: search.salePriceMin,
    salePriceMax: search.salePriceMax,
    rentPriceMin: search.rentPriceMin,
    rentPriceMax: search.rentPriceMax,
    region: search.region,
    locality: search.locality,
    returnTo: search.returnTo,
  });
